import React from "react";
import { Box, Container, Divider, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import "./Footer.css";
export default function Footer() {

    const curYear = new Date().getFullYear()


  return (
    <Box component="footer" sx={{ mt: 4, pb: 6 }}>
      <Container maxWidth="lg">
        <Divider sx={{ mb: 3 }} />
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems={{ xs: "flex-start", md: "center" }}
          justifyContent="space-between"
        >
          <Box className='footer-box'>
            <Typography sx={{ fontWeight: 900 }}>© {curYear} - Brainwave Solutions</Typography>
            <Typography variant="body2" color="var(--color4)">
              Burley, Idaho • Assisting clients worldwide
            </Typography>
            <Box className="footer-link-box">
              <Link component={RouterLink} to="/privacy" underline="hover" color="var(--color3)">
              • privacy policy • 
              </Link>
            </Box>
          </Box>
          </Stack>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ sm: "center" }}>
            <Link component={RouterLink} to="/contact" underline="hover" color="text.secondary">
              Contact
            </Link>
            <Link href="mailto:nate.parish@brainwavesolutions.net" underline="hover" color="text.secondary">
              nate.parish@brainwavesolutions.net
            </Link>
          </Stack>
        
      </Container>
    </Box>
  );
}